module.exports = __webpack_public_path__ + "7e4b29ba/img/placeholder.888fcd0b.svg";